import { render, staticRenderFns } from "./centers.vue?vue&type=template&id=bb14c362&"
import script from "./centers.vue?vue&type=script&lang=js&"
export * from "./centers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports